import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { commonHeadersWeb } from 'src/consumer/services'
import { getData } from 'src/consumer/services/profileService'
import ActivityPlanPage from '.'
import { selectSetupData, setProfileData, setSetupData } from 'src/consumer/reducers/personalData/personalDataReducer'

export default function ActivityPlanWebViewWrapper({ useId, propPlanId, isWebView = false }) {
  const receivedSetupData = useSelector(selectSetupData)
  // const { refreshLocaleData } = useContext(LocalizationContext)

  const dispatch = useDispatch()

  function setReceivedSetupData(data) {
    dispatch(setSetupData(data))
  }

  function setReceivedProfileData(data) {
    dispatch(setProfileData(data))
  }

  async function fetchSetupData() {
    try {
      const resp = await getData('/api/secure/setup')
      if (resp?.status === 200) {
        setReceivedSetupData(resp.data)
      }
    } catch (error) {
      console.log('setup api failed')
    }
  }

  const fetchProfileData = async () => {
    try {
      const resp = await getData('/api/secure/user/profile')
      if (resp?.status === 200) {
        setReceivedProfileData(resp.data)
        localStorage.setItem('authorities', JSON.stringify(resp?.data?.authorities))
      }
    } catch (error) {
      console.log(error)
      // Handle any errors from the data fetching here
    }
  }

  useEffect(() => {
    try {
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.iosBridge
      ) {
        window.webkit.messageHandlers.iosBridge.postMessage({ method: 'getUserToken' })
        window.webkit.messageHandlers.iosBridge.postMessage({ method: 'setAumhumRequestHeaders' })
      }
    } catch (error) {
      console.error('Got error in calling iOS interface method:', error)
    }

    // Exposing setting methods for iOS to use
    window.setToken = function (token) {
      try {
        console.debug(token)
        localStorage.setItem('token', token)
      } catch (error) {
        console.error('Error setting token:', error)
      }
    }

    window.setAumhumRequestHeaders = function (headers) {
      try {
        console.log('headers from IOS is ' + headers)
        replaceHeadersAndCallSetupAPI(headers)
      } catch (error) {
        console.error('Error setting Headers:', error)
      }
    }

    // Call Android interface methods
    if (window.Android && typeof window.Android.getUserToken === 'function') {
      const tokenFromAndroid = window.Android.getUserToken()
      console.log('user token from android is  ' + tokenFromAndroid)
      localStorage.setItem('token', tokenFromAndroid)
    }

    if (window.Android && typeof window.Android.setAumhumRequestHeaders === 'function') {
      const headers = window.Android.setAumhumRequestHeaders()
      console.log('headers from token from android  ' + headers)
      replaceHeadersAndCallSetupAPI(headers)
    }

    function replaceHeadersAndCallSetupAPI(headers) {
      const parsedHeaders = JSON.parse(headers)

      localStorage.setItem('countryCode', parsedHeaders['ef-user-country-code'])
      localStorage.setItem('languageCode', parsedHeaders['ef-app-language'])
      sessionStorage.setItem('languageCode', parsedHeaders['ef-app-language'])

      for (let key of Object.keys(parsedHeaders)) {
        commonHeadersWeb[key] = parsedHeaders[key] || commonHeadersWeb[key]
      }
      !receivedSetupData && fetchSetupData()
    }
  }, [])

  return (
    receivedSetupData && (
      <ActivityPlanPage
        propPlanId={propPlanId}
        setupData={receivedSetupData}
        setupLoading={false}
        useId={useId}
        isWebView
      />
    )
  )
}
